import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { style: {"width":"110px"} }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"width":"110px"} }, "day(test)", -1)
const _hoisted_4 = { style: {"width":"110px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_custom_select = _resolveComponent("custom-select")
  const _component_panel_list = _resolveComponent("panel-list")

  return (_openBlock(), _createBlock(_component_panel_list, {
    column: _ctx.panelListColumn,
    data: _ctx.formData
  }, {
    IntervalType: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.formData.IntervalType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.IntervalType = $event)),
          onChange: _ctx.changeIntervalType
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: 0 }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextMonthly) + "(" + _toDisplayString(_ctx.$wordList.ThirtyDays) + ")", 1)
              ]),
              _: 1
            }),
            (_ctx.isDevOrTest)
              ? (_openBlock(), _createBlock(_component_el_radio_button, {
                  key: 0,
                  label: 3
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_radio_button, { label: 100 }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$wordList.Manual), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _withDirectives(_createVNode("div", { class: "p-left-sm" }, _toDisplayString(_ctx.selectList[0]&&_ctx.selectList[0].TimeZone), 513), [
          [_vShow, _ctx.formData.IntervalType!==100]
        ])
      ])
    ]),
    Cycles: _withCtx(() => [
      _createVNode(_component_custom_select, {
        modelValue: _ctx.formData.Cycles,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Cycles = $event)),
        filterable: "",
        options: _ctx.cyclesOptions
      }, null, 8, ["modelValue", "options"])
    ]),
    numberTitle: _withCtx((scope) => [
      _createVNode("b", null, _toDisplayString(scope.labelValue), 1)
    ]),
    number: _withCtx(() => [
      _createVNode("b", null, _toDisplayString(_ctx.selectList.length), 1)
    ]),
    TotalPriceTitle: _withCtx((scope) => [
      _createVNode("b", null, _toDisplayString(scope.labelValue), 1)
    ]),
    TotalPrice: _withCtx(() => [
      (_ctx.computePriceLoading)
        ? (_openBlock(), _createBlock("span", _hoisted_5, [
            _createVNode("b", null, _toDisplayString(_ctx.$wordList.Calculating), 1)
          ]))
        : (_openBlock(), _createBlock("span", _hoisted_6, [
            _createVNode("b", null, "$" + _toDisplayString(_ctx.formData.TotalPrice), 1)
          ]))
    ]),
    _: 1
  }, 8, ["column", "data"]))
}